import { AbiItem } from 'web3-utils'

export const RAW_DIGITALTWINABI = [
  {
    inputs: [
      {
        internalType: 'address',
        name: '_owner',
        type: 'address',
      },
    ],
    name: 'balancesOf',
    outputs: [
      {
        internalType: 'uint256[]',
        name: 'tokenIds',
        type: 'uint256[]',
      },
      {
        internalType: 'string[]',
        name: 'uris',
        type: 'string[]',
      },
    ],
    stateMutability: 'view',
    type: 'function',
  },
] as const

export const DigitalTwinABI = RAW_DIGITALTWINABI as unknown as AbiItem[]
